<script setup lang="ts">
import type { KanbanTimeOff } from '../../model/interfaces'

import { BadgeTimeOff } from '@shared/ui/badges'
import { AppText } from '@shared/ui/typography'

import { useTimeOffItem } from '../../model/time-off-item.hook'
import TimeOffRow from './TimeOffRow.vue'
import TimeOffBooking from './TimeOffBooking.vue'

defineOptions({
  name: 'TimeOffItem',
})

const props = defineProps<{
  timeOff: KanbanTimeOff
}>()

const {
  refStatusText,
  refStatusMode,
  refAbsenceRange,
  refTimezoneLabel,
  refTarText,
  refTarStatusText,
  refCreatedAt,
} = useTimeOffItem({ timeOff: computed(() => props.timeOff) })

</script>

<template>
  <div class="time-off-item">
    <AppText
      name="body1-medium"
      color="slate-900"
    >
      Time off request
    </AppText>
    <div class="time-off-item__body">
      <TimeOffRow label="Status:">
        <BadgeTimeOff :mode="refStatusMode">
          {{ refStatusText }}
        </BadgeTimeOff>
      </TimeOffRow>
      <TimeOffRow label="Absence date(-s):">
        <AppText
          name="body1-medium"
        >
          {{ refAbsenceRange }}
        </AppText>
        <AppText
          v-if="refTimezoneLabel"
          name="body2"
          color="slate-500"
        >
          {{ refTimezoneLabel }}
        </AppText>
      </TimeOffRow>
      <TimeOffRow label="Predicted TAR:">
        <AppText
          name="body1-medium"
        >
          {{ refTarText }}
        </AppText>
        <AppText
          name="body1"
        >
          {{ refTarStatusText }}
        </AppText>
      </TimeOffRow>
      <div
        v-if="timeOff.bookings.length"
        class="time-off-item__lessons"
      >
        <AppText
          name="body1"
          class="time-off-item__lessons-label"
        >
          Canceled lessons:
        </AppText>
        <TimeOffBooking
          v-for="booking in timeOff.bookings"
          :key="booking.id"
          :booking="booking"
        />
      </div>
    </div>
    <AppText
      name="body2"
      color="slate-400"
    >
      {{ refCreatedAt }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./TimeOffItem.scss" />
